import { render, staticRenderFns } from "./PaymentTypeEdit.vue?vue&type=template&id=10132095&lang=pug"
import script from "./PaymentTypeEdit.vue?vue&type=script&lang=js"
export * from "./PaymentTypeEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports